import { useContext } from 'react';

import { RealtimeContext } from './context';

/**
 * Reading the socket's state without touching a socket.
 *
 * Separate from the provider so that file exports components only, which is
 * what keeps fast refresh working during development.
 */
export function useRealtime() {
  return useContext(RealtimeContext);
}

/** Is the other side typing in this conversation right now? */
export function useIsTyping(conversationId) {
  const { typing } = useRealtime();
  const expires = typing[conversationId];
  return Boolean(expires && expires > Date.now());
}
